import Breadcrumbs from "../../../components/breadcrumbs";
import GreetingMembershipCreateForm from "./ui/greeting-membership-create-form";

export default function GreetingMembershipCreatePage() {
  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Greeting Memberships", href: "/admin/greeting-memberships" },
          {
            label: "Create",
            href: "/admin/greeting-memberships/create",
            active: true,
          },
        ]}
      />
      <GreetingMembershipCreateForm />
    </main>
  );
}
